import React, { useState } from 'react';
import { Component } from 'react';
import {useNavigate} from 'react-router-dom';
import SafeDisplayText from './displaytexthtml';

import { useShop } from './shopinfo';




const Kontakt = () => {
 
  const { shopData } = useShop();

  //console.log("Current shop data:", shopData); 

  if (!shopData) return (<div>
                            <div className="mainContentWrapper">
                              <div className="contentContainer">
                                <div className="landingPageText">
                                    <br />
                                    <h4>Kontakt vom Demotestshop</h4>
                                    <br />
                                    Dieser Text wird angezeigt, wenn keine ID übermittelt wird.
                                    <br />
                                
                                </div>
                              </div>
                            </div>
                          </div>  
                      );
  
  return (
              <div>
                <div className="mainContentWrapper">
                  <div className="contentContainer">
                      <div className="landingPageText">
                          <br />
                          <h4>Kontakt</h4>
                          <br />
                          <SafeDisplayText html={shopData.kontakt_footer} />
                      
                      </div>
                    </div>
                  </div>
              </div>  


  );
};

export default Kontakt;




